<div class="container">
    <form class="page initial-state justify-center">
        <div class="page-box">
            <img src="assets/logo_login.png" class="logo" alt="safaera logo with slogan only planes cheveres">
    
            <mat-form-field color="accent" class="page-form-control" appearance="outline">
                <mat-label>Usuario partner</mat-label>
                <input matInput type="text" (keyup)="authService.error = ''" autocomplete="email" #userName>
            </mat-form-field>
  
            <mat-form-field color="accent" class="page-form-control" appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="type" (keyup)="authService.error = ''" autocomplete="current-password" #userPassword>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'password'">visibility</mat-icon>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'text'">visibility_off</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="authService.error">
                {{authService.error}}
            </mat-error>
            <span class="page-text">
                ¿Olvidaste tu contraseña?
                <div  routerLink="/forgot-password" class="page-link">
                    Recupérala
                </div> 
            </span>
            <button mat-raised-button color="primary" class="page-button" (click)="authService.signIn(userName.value.toLocaleLowerCase() , userPassword.value)">Log In</button>
          
            <div class="page-text mat-body-1">
                <div>¿No tienes una cuenta?</div> 
                <div class="redirect" routerLink="/register-user" class="page-link"> Registrarte como partner</div>
            </div>
        </div>
    </form>
    <img  src="assets/safaera_login_image.jpg"  class="login-image" alt="a man in a concert doing rock signs">
</div>
